import { render, staticRenderFns } from "./previousExhibitions.vue?vue&type=template&id=6b28e518&scoped=true"
import script from "./previousExhibitions.vue?vue&type=script&lang=js"
export * from "./previousExhibitions.vue?vue&type=script&lang=js"
import style0 from "./previousExhibitions.vue?vue&type=style&index=0&id=6b28e518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28e518",
  null
  
)

export default component.exports